import { EventEmitter, Injectable, Output } from '@angular/core';
import { TopicAnswers } from '@app/_models';

@Injectable({ providedIn: 'root' })
export class TopicShareService {

    @Output()
    public emitter: EventEmitter<boolean> = new EventEmitter();

    constructor() { }

}